import axios from 'axios';
import DeleteService from '../../usecases/ports/DeleteService';
import { DEV_DELETE_FUNCTIONS_URL } from '../../constants/routes/urls';

const DELETE_PURCHASED_ITEM_URL = `${DEV_DELETE_FUNCTIONS_URL}/purchase/item/delete`;
const DELETE_INSTRUCTORS_URL = `${DEV_DELETE_FUNCTIONS_URL}/users/instructors/delete`;
type Headers = {
  'Content-Type': string;
};

export default class DeleteServiceFirebaseImpl implements DeleteService {
  headers: Headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };

  deletePurchasedItem = async (purchaseId: string): Promise<void> => {
    const params = new URLSearchParams({ purchaseId: purchaseId });

    return axios
      .post(DELETE_PURCHASED_ITEM_URL, params, { headers: this.headers })
      .then(() => {
        return;
      })
      .catch((error) => {
        throw error;
      });
  };

  deleteInstructors = async (ids: string[]): Promise<void> => {
    const params = {
      ids: ids,
    };

    return axios
      .post(DELETE_INSTRUCTORS_URL, params, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(() => {
        return;
      })
      .catch((error) => {
        throw error;
      });
  };
}
